<template>
  <div>
    <!-- Payment Form -->
    <div id="payment-form"></div>

    <v-overlay :value="overlay" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "PayLoan",

  data() {
    return {
      overlay: false,
      entityId: "",
      checkoutId: "",
    };
  },

  created() {
    this.checkoutId = this.$route.query.checkoutId;
    this.entityId = this.$route.query.entityId;

    console.log("checkoutId:", this.checkoutId);
    console.log("entityId:", this.entityId);
  },

  mounted() {
    this.initializeCheckout();
  },

  methods: {
    // initializeCheckout
    initializeCheckout() {
      const script = document.createElement("script");
      script.src = "https://sandbox-checkout.peachpayments.com/js/checkout.js";
      script.onload = () => {
        this.setupCheckout();
      };
      document.head.appendChild(script);
    },

    // setupCheckout
    setupCheckout() {
      const checkout = Checkout.initiate({
        key: this.entityId,
        checkoutId: this.checkoutId,
        options: {
          theme: {
            brand: {
              primary: "#ff0000",
            },
            cards: {
              background: "#ffffff",
              backgroundHover: "#F3F3F4",
            },
          },
          ordering: {
            PAYFLEX: 1,
            CARD: 2,
          },
        },
        events: {
          onCompleted: (event) => {
            console.log("Checkout Completed:", event);
            this.handleCheckoutCompletion(event);
          },
          onCancelled: (event) => {
            console.log("Checkout Cancelled:", event);
            this.handleCheckoutCancellation(event);
          },
          onExpired: (event) => {
            console.log("Checkout Expired:", event);
            this.handleCheckoutExpiration(event);
          },
        },
      });

      checkout.render("#payment-form");
    },

    // handleCheckoutCompletion
    handleCheckoutCompletion(event) {
      this.overlay = false;
      const transactionMessage = event.resultDetails.ExtendedDescription;
      const transactionSubMessage = event.result.description;
      console.log("Payment successful!", event);

      console.log("recon.........!", event.recon.resultCode);
      // You can redirect the user or show a success message here
      this.$swal.fire({
        icon: "success",
        title: transactionMessage,
        text: transactionSubMessage,
        showConfirmButton: true,
      });

      this.$router.push({
        name: "DashboardSigningLoanAgreementPage",
      });
    },

    // handleCheckoutCancellation
    handleCheckoutCancellation(event) {
      this.overlay = false;

      const transactionMessage = event.result.description;

      this.$swal.fire({
        icon: "success",
        title: transactionMessage,
        showConfirmButton: true,
      });

      this.$router.push({
        name: "DashboardSigningLoanAgreementPage",
      });
    },

    // handleCheckoutExpiration
    handleCheckoutExpiration(event) {
      this.overlay = false;
      console.log("Payment expired!", event);

      this.$swal.fire({
        icon: "error",
        title: "Payment expired!",
        text: "payment session has expired. Please try again ",
        showConfirmButton: true,
      });

      this.$router.push({
        name: "DashboardSigningLoanAgreementPage",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// Your styles here

#payment-form {
  height: 500px;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-radius: 10px;
}
</style>
